var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filter-container",
      on: {
        dragstart: _vm.handleDragStart,
        dragend: function ($event) {
          return _vm.handleDragEnd()
        },
      },
    },
    [
      _c("div", { staticClass: "widget-subject" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "filter-widget-content" },
          _vm._l(_vm.assistList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: "filter-widget " + (item.defaultClass || ""),
                attrs: {
                  "data-id": item.id,
                  draggable: "",
                  "data-index": index,
                },
              },
              [
                _c("div", { staticClass: "filter-widget-icon" }, [
                  _c("i", {
                    class: (item.icon || "el-icon-setting") + " widget-icon-i",
                  }),
                ]),
                _c("div", { staticClass: "filter-widget-text" }, [
                  _vm._v(_vm._s(item.label)),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "widget-subject" }, [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "filter-widget-content" },
          _vm._l(_vm.pictureList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: "filter-widget " + (item.defaultClass || ""),
                attrs: {
                  "data-id": item.id,
                  "data-index": index,
                  draggable: "",
                },
              },
              [
                _c("div", { staticClass: "filter-widget-icon" }, [
                  _c("i", {
                    class: (item.icon || "el-icon-setting") + " widget-icon-i",
                  }),
                ]),
                _c("div", { staticClass: "filter-widget-text" }, [
                  _vm._v(_vm._s(item.label)),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "widget-subject" }, [
        _vm._m(2),
        _c(
          "div",
          { staticClass: "filter-widget-content" },
          _vm._l(_vm.otherList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: "filter-widget " + (item.defaultClass || ""),
                attrs: {
                  "data-id": item.id,
                  "data-index": index,
                  draggable: "",
                },
              },
              [
                _c("div", { staticClass: "filter-widget-icon" }, [
                  _c("i", {
                    class: (item.icon || "el-icon-setting") + " widget-icon-i",
                  }),
                ]),
                _c("div", { staticClass: "filter-widget-text" }, [
                  _vm._v(_vm._s(item.label)),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c("input", {
        ref: "files",
        attrs: { id: "input", type: "file", hidden: "" },
        on: { change: _vm.handleFileChange },
      }),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-header" }, [
      _c("div", { staticClass: "filter-header-text" }, [_vm._v(" 样式")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-header" }, [
      _c("div", { staticClass: "filter-header-text" }, [
        _c("span", [_vm._v("多媒体")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-header" }, [
      _c("div", { staticClass: "filter-header-text" }, [
        _c("span", [_vm._v("其他")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }